import { render, staticRenderFns } from "./TemplateBlock.vue?vue&type=template&id=8f3e273e&"
import script from "./TemplateBlock.vue?vue&type=script&lang=js&"
export * from "./TemplateBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports